import './js-accordions.js?v=3.0.23';
import './js-anchors.js?v=3.0.23';
import './js-card-product.js?v=3.0.23';
import './js-cart.js?v=3.0.23';
import './js-drawers.js?v=3.0.23';
// import './js-filters.js?v=3.0.23';
import './js-form--newsletter.js?v=3.0.23';
import './js-global.js?v=3.0.23';
import './js-header.js?v=3.0.23';
import './js-header-submenu.js?v=3.0.23';
import './js-load-more.js?v=3.0.23';
import './js-module-carousel.js?v=3.0.23';
import './js-popups.js?v=3.0.23';
import './js-widget-player.js?v=3.0.23';
